import { useGetTeamsQuery } from "../../../features/teams/teamsApi";
import TeamMemberItem from "./TeamMemberItem";

const TeamMemberList = () => {
  const { data: teams, isLoading, isError } = useGetTeamsQuery();

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div>Loading...</div>;
  }

  if (!isLoading && isError) {
    content = <div>There was an error!</div>;
  }

  if (!isLoading && !isError && teams?.length === 0) {
    content = <div>No teams found!</div>;
  }

  if (!isLoading && !isError && teams?.length > 0) {
    content = teams.map((team) => <TeamMemberItem key={team.id} team={team} />);
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default TeamMemberList;
